import _ from 'lodash';
import { useMemo } from 'react';

import { BoxProps } from '@mui/material';
import { IndexFredCode } from 'generated/graphql';

import {
  LightSummaryMetricCardLayout,
  StandardSourceMetricCard
} from 'modules';



export type LightDashboardMetricCardProps = {
  dataSource: string;
  dataLink: string;
  data: StandardSourceMetricCard.StandardSourceMetricCardProps[];
  metrics: IndexFredCode[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends (StandardSourceMetricCard.StandardSourceMetricCardProps)[]>(props: LightDashboardMetricCardProps & BoxProps) => {
  const cardData = useMemo(
    () => _.compact(props.metrics.map((metric) => props.data.find((node) => node.fredCode === metric))),
    [
      props.data,
      props.metrics
    ]
  );

  return (
    <LightSummaryMetricCardLayout.FC
      dataLink={props.dataLink}
      dataSource={props.dataSource}
    >
      {cardData.map((metric, i) => (
        <StandardSourceMetricCard.FC
          key={`${metric.fredCode}-${i}`}
          {...metric}
          color='SECONDARY'
        />
      ))}
    </LightSummaryMetricCardLayout.FC>
  );
};
